/**
 * Shared constants & types for attribution / source tracking.
 *
 * The values here MUST stay in sync with the check constraints defined in
 * `supabase/migrations/20260421140000_add_attribution_fields.sql`.
 */

export const LEAD_SOURCES = [
  'Referral',
  'Website',
  'Cold Call',
  'Door Knock',
  'Event',
  'Other',
] as const;

export type LeadSource = (typeof LEAD_SOURCES)[number];

export const isLeadSource = (value: unknown): value is LeadSource =>
  typeof value === 'string' && (LEAD_SOURCES as readonly string[]).includes(value);

export const BOOKING_SOURCES = [
  'admin_manual',
  'homeowner_request',
  'automation',
] as const;

export type BookingSource = (typeof BOOKING_SOURCES)[number];

export const BOOKING_SOURCE_LABELS: Record<BookingSource, string> = {
  admin_manual: 'Admin booked',
  homeowner_request: 'Homeowner requested',
  automation: 'Automation',
};

export const isBookingSource = (value: unknown): value is BookingSource =>
  typeof value === 'string' &&
  (BOOKING_SOURCES as readonly string[]).includes(value);
